import type { Update, Message, CallbackQuery, User, Chat, ChatMessage } from '../types/telegram';
import { DEFAULT_USER, DEFAULT_CHAT } from './constants';

let updateIdCounter = 0;
let messageIdCounter = 0;

export function resetCounters(): void {
  updateIdCounter = 0;
  messageIdCounter = 0;
}

export function getNextUpdateId(): number {
  return ++updateIdCounter;
}

export function getNextMessageId(): number {
  return ++messageIdCounter;
}

export function setMessageIdCounter(value: number): void {
  messageIdCounter = value;
}

export function createUser(overrides?: Partial<User>): User {
  return { ...DEFAULT_USER, ...overrides };
}

export function createChat(overrides?: Partial<Chat>): Chat {
  return { ...DEFAULT_CHAT, ...overrides } as Chat;
}

export function createMessage(text: string, overrides?: Partial<Message>): Message {
  return {
    message_id: getNextMessageId(),
    date: Math.floor(Date.now() / 1000),
    chat: createChat(),
    from: createUser(),
    text,
    ...overrides,
  };
}

export function createChatMessage(
  text: string,
  direction: 'incoming' | 'outgoing',
  overrides?: Partial<Message>
): ChatMessage {
  return {
    ...createMessage(text, overrides),
    direction,
  };
}

export function createMessageUpdate(text: string): Update {
  return {
    update_id: getNextUpdateId(),
    message: createMessage(text),
  };
}

export function createCallbackQuery(
  data: string,
  message: Message,
  overrides?: Partial<CallbackQuery>
): CallbackQuery {
  return {
    id: crypto.randomUUID(),
    from: createUser(),
    message,
    chat_instance: crypto.randomUUID(),
    data,
    ...overrides,
  };
}

export function createCallbackQueryUpdate(data: string, message: Message): Update {
  return {
    update_id: getNextUpdateId(),
    callback_query: createCallbackQuery(data, message),
  };
}
